import { render, staticRenderFns } from "./reisen-metadata-card-releaseinformationen.vue?vue&type=template&id=ab845fcc&scoped=true"
import script from "./reisen-metadata-card-releaseinformationen.vue?vue&type=script&lang=js"
export * from "./reisen-metadata-card-releaseinformationen.vue?vue&type=script&lang=js"
import style0 from "./reisen-metadata-card-releaseinformationen.vue?vue&type=style&index=0&id=ab845fcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab845fcc",
  null
  
)

export default component.exports